import { render, staticRenderFns } from "./StandardNew.vue?vue&type=template&id=1fcc75ef&"
import script from "./StandardNew.vue?vue&type=script&lang=js&"
export * from "./StandardNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports